import * as React from 'react';
import { MonografiaModel, editarTituloMonografiaDoAluno, editarSituacaoDepositoDoAluno } from '../../../Store';
import { Card, CardTitle, CardContent, Input, Button, Toast, ToastType } from '../../../Components';
import styled from 'styled-components';
import { format } from 'date-fns';
import { useState } from 'react';

interface IDetalhesMonografiaProps {
  monografia: MonografiaModel
}

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 10px;
`;

const StyledInput = styled(Input) <any>`
  margin: 0;
  grid-column: ${p => p.gridColumn}
`;

const StyledText = styled.span`
  padding: 5px;
`;

const DetalhesMonografiaCard: React.FC<IDetalhesMonografiaProps> = ({ monografia } : IDetalhesMonografiaProps) => {

  const AlterarTitulo = async (id: number, titulo: string) => {
    await editarTituloMonografiaDoAluno(id, titulo);
    setAlterar(false);
    setConfirmar(false);
    setSucesso(true);
    }

  const ReprovarDeposito = async (id: number) => {
    await editarSituacaoDepositoDoAluno(id);
    window.location.href = "/funcionario";
  }

  const [titulo, setTitulo] = useState(monografia.titulo)
  const [alterar, setAlterar] = useState(false)
  const [confirmar, setConfirmar] = useState(false)
  const [sucesso, setSucesso] = useState(false)
  const [confirmarDeposito, setConfirmarDeposito] = useState(false)

  function onTituloChange(e: { target: { value: React.SetStateAction<string>; }; }){
    setTitulo(e.target.value)
  }

  return (
    <>
    {sucesso &&
          <Toast type={ToastType.success}>
            <StyledText>Título Alterado</StyledText>
          </Toast> }
    <Card>
      <CardTitle>TCC</CardTitle>
      <CardContent>
        <StyledContainer>
          {!confirmar &&
          <>
          <StyledInput
            value={monografia.aluno.nome}
            label='Aluno'
            disabled={true}
          />
          <div>
          <StyledInput
            value={monografia.aluno.matricula}
            label='Matricula'
            disabled={true}
            gridColumn = '1/2'
          />
          <StyledInput
            value={monografia.aluno.email}
            label='Email'
            disabled={true}
            gridColumn='2/14'
          />
          </div>
          <StyledInput
            value={monografia.professor.nome}
            label='Orientador'
            disabled={true}
          />
          </>
          }
          <StyledInput
            value={titulo}
            label='Título'
            onChange={onTituloChange}
            disabled={confirmar ? false : true}
          />
          {!confirmar &&
          <StyledInput
            value={format(monografia.deposito!.dataDoDeposito, 'DD/MM/YYYY')}
            label='Data do Depósito'
            disabled={true}
          />}

          {!alterar &&
          <Button onClick={() => {
            setConfirmar(true);
            setAlterar(true);
            setSucesso(false);
            setConfirmarDeposito(false);
          }}>
            Alterar Título
          </Button>}

          {confirmar &&
          <Button onClick={() => {
            AlterarTitulo(monografia.id, titulo);
          }}>
            Confirmar
          </Button>}

          {!alterar && !confirmarDeposito && !monografia.agendamento &&
          <Button color={'errorColor'} onClick={() => {
            setConfirmarDeposito(true);
          }}>
            Recusar Depósito
          </Button>}

          {confirmarDeposito && 
          <Button color={'errorColor'} onClick={() => {
            ReprovarDeposito(monografia.id);
          }}>
            Confirmar - Recusar Depósito
          </Button>}
        </StyledContainer>
      </CardContent>
    </Card>
    </>
  );
};

export default DetalhesMonografiaCard;